import React from "react";
import { useSettings } from "@/hooks/useSettings";
import RainSounds from "./RainSounds";
import SpotifyPlayer from "./SpotifyPlayer";

const AudioWidget: React.FC = () => {
  const { settings } = useSettings();

  switch (settings.sound.type) {
    case "rain":
      return <RainSounds />;
    case "spotify":
      return <SpotifyPlayer />;
    case "none":
    default:
      return null;
  }
};

export default AudioWidget;
